import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LESSON_FLOW_STATE_TYPE {
  activityId: number;
  nextActive: boolean;
  didUpdate: boolean;
}

const INITIAL_STATE: LESSON_FLOW_STATE_TYPE = {
  activityId: 0,
  nextActive: false,
  didUpdate: false,
};

const lessonFlowSlice = createSlice({
  name: 'lessonFlow',
  initialState: INITIAL_STATE,
  reducers: {
    setLessonActivityId(state: LESSON_FLOW_STATE_TYPE, action: PayloadAction<number>) {
      state.activityId = action.payload;
    },
    setNextActive(state: LESSON_FLOW_STATE_TYPE, action: PayloadAction<boolean>) {
      state.nextActive = action.payload;
    },
    setActivityDidUpdate(state: LESSON_FLOW_STATE_TYPE, action: PayloadAction<boolean>) {
      state.didUpdate = action.payload;
    },
  },
});

export const { setLessonActivityId, setNextActive, setActivityDidUpdate } = lessonFlowSlice.actions;

export default lessonFlowSlice.reducer;
